import "./notification.scss";
import Success from '../../../assets/images/icons/check.png';
import Error from '../../../assets/images/icons/close.png';
import Warning from '../../../assets/images/icons/caution.png';
import Info from '../../../assets/images/icons/info-blue.png';

import React, { FunctionComponent, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../features";
import { getNotification, setResetNotification } from "../../../store/NotificationSlice";

const NOTIFICATION_TIMER = 2000;

export const Notification: FunctionComponent = () => {

    const dispatch = useAppDispatch();
    const isToShow = useAppSelector(getNotification);

    const [show, setShow] = useState(false);

    const imgSelection = () => {
        if (isToShow.class === 'success' ) return Success;
        if (isToShow.class === 'error' ) return Error;
        if (isToShow.class === 'warning' ) return Warning;
        return Info;
    }

    useEffect(() => {

        const timerToShow = setTimeout(() => {
            setShow(true);
        }, 100);

        const timer = setTimeout(() => {
            setShow(false);
        }, NOTIFICATION_TIMER);

        const timerDispatch = setTimeout(() => {
            dispatch(setResetNotification());
        }, (NOTIFICATION_TIMER + 100));

        return () => {
            clearTimeout(timerToShow);
            clearTimeout(timer);
            clearTimeout(timerDispatch);
        };

    }, [isToShow, dispatch]);

    if (!isToShow.status) return null;

    return (
        <div className={`notification-wrapper ${isToShow.class} ${isToShow.position} ${show ? 'show' : ''}`}>
            <img src={imgSelection()} alt="" />
            <div className="text">
                {isToShow.title && (
                    <h1>
                        {isToShow.title}
                    </h1>
                )}
                <p>
                    {isToShow.msg}                
                </p>
            </div>
        </div>
    )
}